// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"tnBrQlF2_x4jL4HZCzLA0"};